import { render, staticRenderFns } from "./SlideDeckPublish.modal.vue?vue&type=template&id=45761103"
import script from "./SlideDeckPublish.modal.vue?vue&type=script&lang=ts"
export * from "./SlideDeckPublish.modal.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckPublish.modal.vue?vue&type=style&index=0&id=45761103&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports